import React from "react";
import { FaMinus, FaPlus } from "react-icons/fa";
import "../../pages/ProductPreview.css";

// The Buyer quantity selector (.quantity-selector / -btn / -input from ProductPreview.css).
export default function QtyStepper({ value, max, step = 1, onChange, label }) {
  const v = Number(value) || 0;
  return (
    <div className="quantity-selector">
      <button type="button" className="quantity-btn quantity-minus" aria-label={`- ${label || ""}`.trim()} disabled={v <= 0} onClick={() => onChange(Math.max(0, v - step))}><FaMinus /></button>
      <input type="number" className="quantity-input" min="0" max={max} aria-label={label} value={v} onChange={(e) => onChange(e.target.value)} />
      <button type="button" className="quantity-btn quantity-plus" aria-label={`+ ${label || ""}`.trim()} disabled={v >= max} onClick={() => onChange(Math.min(max, v + step))}><FaPlus /></button>
    </div>
  );
}
